const trailers = [
    {
        "id": 1,
        "name": "High Bed",
        "filedid": "high",
        "products": [
            {
                "id": 1,
                "name": "Ashok Leyland 3516",
                "quantity": 15,
                "capacity": "22 MT",
                "type": "High bed double axle trailer",
                "Image": "/product/trailers/high/High bed trailer (10).jfif"
            },
            {
                "id": 2,
                "name": "TATA 3516",
                "quantity": 12,
                "capacity": "22 MT",
                "type": "High bed double axle trailer",
                "Image": "/product/trailers/high/High bed trailer (15).jfif"
            },
            {
                "id": 3,
                "name": "Ashok Leyland 4018",
                "quantity": 25,
                "capacity": "30 MT",
                "type": "High bed triple axle trailer",
                "Image": "/product/trailers/high/High bed trailer (21).jfif"
            },
            {
                "id": 4,
                "name": "TATA 4018",
                "quantity": 8,
                "capacity": "30 MT",
                "type": "High bed triple axle trailer",
                "Image": "/product/trailers/high/High bed trailer (22).jfif"
            }
        ]
    },
    {
        "id": 2,
        "name": "Semi Low Bed",
        "filedid": "semi",
        "products": [
            {
                "id": 1,
                "name": "Ashok Leyland 3516",
                "quantity": 15,
                "capacity": "22 MT",
                "type": "High bed double axle trailer",
                "Image": "/product/trailers/semi/Semi low bed trailer (1).jfif"
            },
            {
                "id": 2,
                "name": "TATA 3516",
                "quantity": 12,
                "capacity": "22 MT",
                "type": "High bed double axle trailer",
                "Image": "/product/trailers/semi/Semi low bed trailer (2).jfif"
            },
            {
                "id": 3,
                "name": "Ashok Leyland 4018",
                "quantity": 25,
                "capacity": "30 MT",
                "type": "High bed triple axle trailer",
                "Image": "/product/trailers/semi/Semi low bed trailer (3).jfif"
            },
            {
                "id": 4,
                "name": "TATA 4018",
                "quantity": 8,
                "capacity": "30 MT",
                "type": "High bed triple axle trailer",
                "Image": "/product/trailers/semi/Semi low bed trailer (4).jfif"
            }
        ]
    },
    {
        "id": 3,
        "name": "Low Bed",
        "filedid": "low",
        "products": [
            {
                "id": 5,
                "name": "AMW",
                "quantity": 1,
                "capacity": "35 MT",
                "type": "Full low bed Trailer",
                "Image": "/product/trailers/low/Low bed trailer (1).jfif"
            },
            {
                "id": 6,
                "name": "Ashok Leyland 4923",
                "quantity": 1,
                "capacity": "35 MT",
                "type": "Full low bed triple axle trailer",
                "Image": "/product/trailers/low/Low bed trailer (2).jfif"
            },
            {
                "id": 7,
                "name": "Ashok Leyland Beaver",
                "quantity": 3,
                "capacity": "40 MT",
                "type": "Full low bed trailer with 8 tyres floating axle",
                "Image": "/product/trailers/low/Low bed trailer (3).jfif"
            },
            {
                "id": 8,
                "name": "Ashok Leyland Hippo",
                "quantity": 5,
                "capacity": "100 MT",
                "type": "Full low bed trailer with 16 tyres floating axle",
                "Image": "/product/trailers/low/Low bed trailer (4).jfif"
            }
        ]
    }
];
export default trailers;